/**
 * Detects whether the current environment reports the browser as offline.
 *
 * Reads `navigator.onLine` defensively so the helper stays safe under SSR /
 * node jest environments where `navigator` is missing. Returns `true` only
 * when the browser explicitly signals an offline state — never as a fallback
 * when the API is unavailable.
 *
 * A `false` return value does NOT guarantee that the GraphQL backend is
 * reachable; it only means the browser has *some* network route. The helper
 * is meant to be combined with retry / monitoring / UI logic (cf. TEC-1684).
 */
export const isBrowserOffline = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  return navigator.onLine === false;
};
